// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import React, { useState, useEffect } from "react";
// import { useSearchParams } from "react-router-dom";
// import { IInvoiceItem, IInvoiceData } from "../Interfaces/IInvoice";
// import { getUsers } from "../Services/userService";
// import { getOrganizationDetails } from "../Services/orgService";
// import { useNavigate } from "react-router-dom";
// import "../Style/EditInvoice.css";
// import "../Style/ViewInvoiceDetails.css";
// import "../Style/Common.css";
// import Footer from "../Footer/Footer";
// import { getInvoiceById } from "../Services/InvoicePageService";
// import { getStateCode, printViewInvoicePDF } from "../Services/CommonService";
// import { Container, Box } from "@mui/material";
// const ViewInvoiceDetails: React.FC = () => {
//   const [searchParams] = useSearchParams();
//   const invoiceId = searchParams.get("invoiceId");
//   const [customers, setCustomers] = useState<{
//     id: string;
//     name: string;
//     email: string;
//     phone: string;
//     GSTIN: string;
//     street: string;
//     city: string;
//     state: string;
//     zipCode: string;
//     country: string;
//     companyName: string;
//   } | null>(null);
//   const [orgDetails, setOrgDetails] = useState<any>(null);

//   const [formData, setFormData] = useState<IInvoiceData>({
//     orgId: "",
//     invoiceId: "",
//     customerId: "",
//     orderId: "",
//     orderDate: "",
//     salesPersonId: "",
//     invoiceDate: "",
//     dueDate: "",
//     salesPersonName: "",
//     customerName: "",
//     terms: "Due on receipt",
//     totalTax: 0,
//     totalDiscount: 0,
//     subTotalAmount: 0,
//     shippingCharge: 0,
//     grandTotal: 0,
//     status: "",
//     invoiceType: "",
//     createdBy: "",
//     createdIp: "",
//     itemDetails: [],
//     buyerStateCode: "",
//     sellerStateCode: "",
//     isIntraState: true,
//     totalCGST: 0,
//     totalSGST: 0,
//     buyerGST: "",
//     sellerGST: "",
//     paymentMode: "",
//     totalPaidAmount:0
//   });
//   const navigate = useNavigate();
//   // Function to navigate back to the View Inventory page
//   const handleBackClick = () => {
//     navigate("/dashboard/sales/view-invoice");
//   };

//   const orgId = localStorage.getItem("orgId") || "GOO@PANACCO101";
//   const customerID = localStorage.getItem("customerId") || "CUST01";
//   type TaxSlab = "3" | "5" | "12" | "18" | "28";

//   //Tax summary by tax slab

//   const taxSummary: Record<TaxSlab, number> = {
//     "3": 0,
//     "5": 0,
//     "12": 0,
//     "18": 0,
//     "28": 0,
//   };
//   //Tax summary by tax slab
//   formData.itemDetails.forEach((item) => {
//     const qty = Number(item.qty);
//     const rate = Number(item.price);
//     const discount = Number(item.discount);
//     const tax = Number(item.Tax);
//     const discountedAmount = qty * rate * (1 - discount / 100);
//     const gstAmount = (discountedAmount * tax) / 100;
//     const taxKey = tax.toString() as TaxSlab;
//     if (taxKey in taxSummary) {
//       taxSummary[taxKey] += gstAmount;
//     }
//   });
//   useEffect(() => {
//     const loadCustomers = async () => {
//       try {
//         const customerData = await getUsers(orgId, "customer"); // Pass the orgId dynamically if needed
//         const customersList = customerData.map((customer: any) => ({
//           id: customer.Id,
//           // name: `${customer.salutation} ${customer.firstName} ${customer.lastName}`,
//           name:
//             customer?.customerName ??
//             (customer?.companyName ||
//               [customer?.firstName, customer?.lastName]
//                 .filter(Boolean)
//                 .join(" ")),
//           email: `${customer?.email}`,
//           GSTIN: `${customer?.GSTIN}`,
//           phone: `${customer?.phone}`,
//           street: `${customer?.address?.street}`,
//           city: `${customer?.address?.city}`,
//           state: `${customer?.address?.state}`,
//           zipCode: `${customer?.address?.zipCode}`,
//           country: `${customer?.address?.country}`,
//           companyName: `${customer?.companyName}`,
//         }));
//         const customerDetails = customersList.find(
//           (customer: { id: any }) => customer?.id == customerID
//         );
//         if (customerDetails) {
//           setCustomers(customerDetails); // Update the state with the full customer object
//         } else {
//           console.error("Selected customer not found");
//         }
//       } catch (error) {
//         console.error(
//           "Failed to fetch customer details at invoice detail view page:",
//           error
//         );
//       }
//       try {
//         const orgData = await getOrganizationDetails(orgId);
//         setOrgDetails(orgData);
//       } catch (error) {
//         console.error(
//           "Failed to fetch Org details at invoice creation page",
//           error
//         );
//       }
//     };
//     loadCustomers();
//   }, []);

//   useEffect(() => {
//     const fetchInvoice = async () => {
//       if (!invoiceId || !orgId) return;

//       try {
//         const invoiceData = await getInvoiceById(invoiceId, orgId);
//         setFormData((prev) => ({
//           ...prev,
//           ...invoiceData,
//           invoiceDate: invoiceData.invoiceDate?.split("T")[0] || "",
//           dueDate: invoiceData.dueDate?.split("T")[0] || "",
//           itemDetails: invoiceData.items || [],
//           buyerStateCode:
//             invoiceData?.gstDetails && invoiceData?.gstDetails[0]
//               ? invoiceData?.gstDetails[0]?.buyerStateCode
//               : getStateCode(customers?.state),
//           sellerStateCode:
//             invoiceData?.gstDetails && invoiceData?.gstDetails[0]
//               ? invoiceData?.gstDetails[0]?.sellerStateCode
//               : getStateCode(orgDetails?.address[0]?.state || ""),
//           isIntraState:
//             invoiceData?.gstDetails && invoiceData?.gstDetails[0]
//               ? invoiceData?.gstDetails[0]?.buyerStateCode ===
//                 invoiceData?.gstDetails[0]?.sellerStateCode
//               : getStateCode(customers?.state || "") ===
//                 getStateCode(orgDetails?.address[0]?.state || ""),
//           totalCGST:
//             invoiceData?.gstDetails && invoiceData?.gstDetails[0]
//               ? invoiceData?.gstDetails[0]?.cgst
//               : 0,
//           totalSGST:
//             invoiceData?.gstDetails && invoiceData?.gstDetails[0]
//               ? invoiceData?.gstDetails[0]?.sgst
//               : 0,
//           buyerGST:
//             invoiceData?.gstDetails && invoiceData?.gstDetails[0]
//               ? invoiceData?.gstDetails[0]?.buyerGST
//               : "",
//           sellerGST:
//             invoiceData?.gstDetails && invoiceData?.gstDetails[0]
//               ? invoiceData?.gstDetails[0]?.orgDetails?.GST
//               : orgDetails?.GST ?? "",
//           paymentMode: invoiceData?.paymentMode || "",
//         }));
//       } catch (err) {
//         console.error("Failed to fetch invoice:", err);
//       }
//     };

//     fetchInvoice();
//   }, [invoiceId]);

//   const handlePrint = async () => {
//     try {
//       // Invoice Details (Right Side)

//       const dueDate = new Date(formData.dueDate);
//       const invoiceDate = new Date(formData.invoiceDate);

//       // Format as DD/MM/YYYY
//       const formattedDate = dueDate.toLocaleDateString("en-GB");
//       const formattedInvoiceDate = invoiceDate.toLocaleDateString("en-GB");
//       if (true) {
//         printViewInvoicePDF(orgDetails, formData, customers, taxSummary);
//       }
//     } catch (error: any) {
//       alert(`Failed to print invoice: ${error.message}`);
//     }
//     // End Logic for PDF generation here
//   };

//   return (
//     <>
//       <div className="page-location">
//         <span>Sales &gt; View Invoice &gt; Invoice Details</span>
//       </div>
//       <button onClick={handleBackClick} className="back-button">
//         <i className="fas fa-arrow-left back-icon"></i>
//         Back
//       </button>
//       <Container maxWidth="lg" sx={{ padding: 1 }}>
//         <form>
//           {/* <h2>Invoice Details</h2> */}
//           <form className="invoice-form">
//             <div className="view-form-group">
//               <label>Invoice ID: </label>
//               {formData?.invoiceId}
//             </div>

//             <div className="view-form-group">
//               <label>Customer Name: </label>
//               {formData?.customerName}
//             </div>
//             <div className="view-form-group">
//             <label>Invoice Date: </label>
//             {formData?.invoiceDate
//               ? new Date(formData.invoiceDate).toLocaleDateString("en-GB")
//               : "N/A"}
//           </div>

//             <div className="view-form-group">
//               <label>Buyer's Order No</label>
//               {formData?.orderId}
//             </div>

//             <div className="view-form-group">
//               <label>Buyer's Order Date</label>
//               {/* {formData?.orderDate} */}
//                   {formData?.orderDate
//               ? new Date(formData.orderDate).toLocaleDateString("en-GB")
//               : "N/A"}
//             </div>

//             <div className="view-form-group">
//               <label>Sales Person: </label>
//               {formData?.salesPersonName}
//             </div>
//             <div className="view-form-group">
//               <label>Mode/Terms Payment: </label>
//               {formData?.paymentMode}
//             </div>
//           </form>
//           {/* Add more fields here... */}
//           <div className="invoice-items-container">
//             <h2>Item Details</h2>
//             {formData?.itemDetails?.map((item: IInvoiceItem, index: number) => (
//               <>
//                 <label
//                   style={{
//                     fontWeight: "bold",
//                     fontSize: "1.1rem",
//                     color: "#333",
//                     marginBottom: "5px",
//                     display: "block",
//                   }}
//                 >
//                   Sno: {index + 1}
//                 </label>
//                 <div key={index} className="item-row">
//                   <label>Item Name:</label>
//                   <input
//                     type="text"
//                     placeholder="Item Description"
//                     className="item-input"
//                     value={item?.itemDesc}
//                     // onChange={(e) => handleItemDetailsChange(index, "itemDesc", e.target.value)}
//                     disabled
//                   />
//                   <label>Quantity:</label>
//                   <input
//                     type="number"
//                     placeholder="Quantity"
//                     className="item-input"
//                     value={item?.qty}
//                     //onChange={(e) => handleItemDetailsChange(index, "qty", Number(e.target.value))}
//                     disabled
//                   />
//                   <label>Rate:</label>
//                   <input
//                     type="number"
//                     placeholder="Rate"
//                     className="item-input"
//                     value={item?.price}
//                     //onChange={(e) => handleItemDetailsChange(index, "price", Number(e.target.value))}
//                     disabled
//                   />
//                 </div>
//                 <div key={index} className="item-row">
//                   <label>Discount:</label>
//                   <select
//                     className="item-input"
//                     value={item?.discount}
//                     //onChange={(e) => handleItemDetailsChange(index, "discount", e.target.value)}
//                     disabled
//                   >
//                     <option value="0">No Discount</option>
//                     <option value="5">5%</option>
//                     <option value="10">10%</option>
//                     <option value="15">15%</option>
//                     <option value="20">20%</option>
//                   </select>
//                   <label>Tax:</label>
//                   <select
//                     className="item-input"
//                     value={item?.Tax}
//                     //onChange={(e) => handleItemDetailsChange(index, "Tax", e.target.value)}
//                     disabled
//                   >
//                     <option value="0">Tax Not Applicable</option>
//                     <option value="3">3%</option>
//                     <option value="5">5%</option>
//                     <option value="12">12%</option>
//                     <option value="18">18%</option>
//                     <option value="28">28%</option>
//                   </select>
//                   <label>Total:</label>
//                   <input
//                     type="text"
//                     className="item-input"
//                     value={(
//                       Number(item?.qty) *
//                       Number(item?.price) *
//                       (1 - Number(item?.discount) / 100) * // Apply discount
//                       (1 + Number(item?.Tax) / 100)
//                     ) // Apply tax
//                       .toFixed(2)}
//                     disabled
//                   />
//                 </div>
//               </>
//             ))}
//           </div>
//           <div className="calculation-container">
//             <div className="form-group">
//               <label>
//                 Sub Total: {formData?.subTotalAmount.toFixed(2)}
//               </label>
//               {/* <span className="form-output">{formData.subTotalAmount.toFixed(2)}</span> */}
//             </div>
//             {formData.isIntraState ? (
//               <>
//                 {" "}
//                 <div className="form-group">
//                   <label>
//                     CGST: {formData?.totalCGST?.toFixed(2)}
//                   </label>
//                 </div>
//                 <div className="form-group">
//                   <label>
//                     SGST: {formData?.totalSGST.toFixed(2)}
//                   </label>
//                 </div>
//               </>
//             ) : (
//               <div className="form-group">
//                 <label>IGST: {formData?.totalTax.toFixed(2)}</label>
//               </div>
//             )}
//             <div className="form-group">
//               <label>
//                 Shipping Charge:
//                 {formData?.shippingCharge > 0
//                   ? `${formData?.shippingCharge.toFixed(2)}`
//                   : ""}
//               </label>
//             </div>
//             <div className="form-group">
//               <label>
//                 Total: {formData?.grandTotal.toFixed(2)}{" "}
//               </label>
//             </div>
//             <div className="form-group">
//               <label>
//                 Paid Amount: {formData?.totalPaidAmount.toFixed(2)}{" "}
//               </label>
//             </div>
//           </div>
//           <button type="button" onClick={handlePrint} className="print-button">
//             Print
//           </button>
//         </form>
//       </Container>
//       <Box
//         sx={{
//           position: "relative",
//           left: 0,
//           bottom: 0,
//           width: "100%",
//           mt: 10,
//         }}
//       >
//         <Footer />
//       </Box>
//     </>
//   );
// };
// export default ViewInvoiceDetails;
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { IInvoiceItem, IInvoiceData } from "../Interfaces/IInvoice";
import { getUsers } from "../Services/userService";
import { getOrganizationDetails } from "../Services/orgService";
import { useNavigate } from "react-router-dom";
import "../Style/EditInvoice.css";
import "../Style/ViewInvoiceDetails.css";
import "../Style/Common.css";
import Footer from "../Footer/Footer";
import { getInvoiceById } from "../Services/InvoicePageService";
import { getStateCode, printViewInvoicePDF } from "../Services/CommonService";
import {
  Container,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Stack,
  TextField,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import DownloadIcon from "@mui/icons-material/Download";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { shareInvoicePdf, buildInvoiceWhatsAppMessage } from "../Services/shareInvoiceOnWhatsApp"; // from the earlier batch of files

// One row of your invoiceGstDetails collection.
interface IGstDetailRow {
  gstRate: number;
  taxableValue: number;
  cgst: number;
  sgst: number;
  igst: number;
  totalTax: number;
  buyerStateCode: string;
  sellerStateCode: string;
  buyerGST?: string;
  sellerGST?: string;
}

const ViewInvoiceDetails: React.FC = () => {
  const [searchParams] = useSearchParams();
  const invoiceId = searchParams.get("invoiceId");
  const [customers, setCustomers] = useState<{
    id: string;
    name: string;
    email: string;
    phone: string;
    GSTIN: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    companyName: string;
  } | null>(null);
  const [orgDetails, setOrgDetails] = useState<any>(null);

  // Keep the raw per-slab GST rows around so we can render a correct
  // breakdown table instead of collapsing everything into one number.
  const [gstDetailRows, setGstDetailRows] = useState<IGstDetailRow[]>([]);

  const [formData, setFormData] = useState<IInvoiceData>({
    orgId: "",
    invoiceId: "",
    customerId: "",
    orderId: "",
    orderDate: "",
    salesPersonId: "",
    invoiceDate: "",
    dueDate: "",
    salesPersonName: "",
    customerName: "",
    terms: "Due on receipt",
    totalTax: 0,
    totalDiscount: 0,
    subTotalAmount: 0,
    shippingCharge: 0,
    grandTotal: 0,
    status: "",
    invoiceType: "",
    createdBy: "",
    createdIp: "",
    itemDetails: [],
    buyerStateCode: "",
    sellerStateCode: "",
    isIntraState: true,
    totalCGST: 0,
    totalSGST: 0,
    buyerGST: "",
    sellerGST: "",
    paymentMode: "",
    totalPaidAmount: 0,
    roundOff:0,
  });
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate("/dashboard/sales/view-invoice");
  };

  const orgId = localStorage.getItem("orgId") || "GOO@PANACCO101";
  const customerID = localStorage.getItem("customerId") || "CUST01";
  type TaxSlab = "3" | "5" | "12" | "18" | "28";

  const taxSummary: Record<TaxSlab, number> = {
    "3": 0,
    "5": 0,
    "12": 0,
    "18": 0,
    "28": 0,
  };
  formData.itemDetails.forEach((item) => {
    const qty = Number(item.qty);
    const rate = Number(item.price);
    const discount = Number(item.discount);
    const tax = Number(item.Tax);
    const discountedAmount = qty * rate * (1 - discount / 100);
    const gstAmount = (discountedAmount * tax) / 100;
    const taxKey = tax.toString() as TaxSlab;
    if (taxKey in taxSummary) {
      taxSummary[taxKey] += gstAmount;
    }
  });

  useEffect(() => {
    const loadCustomers = async () => {
      try {
        const customerData = await getUsers(orgId, "customer");
        const customersList = customerData.map((customer: any) => ({
          id: customer.Id,
          name:
            customer?.customerName ??
            (customer?.companyName ||
              [customer?.firstName, customer?.lastName]
                .filter(Boolean)
                .join(" ")),
          email: `${customer?.email}`,
          GSTIN: `${customer?.GSTIN}`,
          phone: `${customer?.phone}`,
          street: `${customer?.address?.street}`,
          city: `${customer?.address?.city}`,
          state: `${customer?.address?.state}`,
          zipCode: `${customer?.address?.zipCode}`,
          country: `${customer?.address?.country}`,
          companyName: `${customer?.companyName}`,
        }));
        const customerDetails = customersList.find(
          (customer: { id: any }) => customer?.id == customerID
        );
        if (customerDetails) {
          setCustomers(customerDetails);
        } else {
          console.error("Selected customer not found");
        }
      } catch (error) {
        console.error(
          "Failed to fetch customer details at invoice detail view page:",
          error
        );
      }
      try {
        const orgData = await getOrganizationDetails(orgId);
        setOrgDetails(orgData);
      } catch (error) {
        console.error(
          "Failed to fetch Org details at invoice creation page",
          error
        );
      }
    };
    loadCustomers();
  }, []);

  useEffect(() => {
    const fetchInvoice = async () => {
      if (!invoiceId || !orgId) return;

      try {
        const invoiceData = await getInvoiceById(invoiceId, orgId);
        const gstRows: IGstDetailRow[] = invoiceData?.gstDetails ?? [];
        setGstDetailRows(gstRows);

        // ─── THE FIX ────────────────────────────────────────────────────
        // gstDetails has ONE ROW PER GST SLAB (3%, 5%, 12%...). The old code
        // read only gstDetails[0], so a second/third slab's CGST & SGST was
        // silently dropped. We now sum every row instead of picking the first.
        const totalCGST = gstRows.reduce((sum, g) => sum + Number(g.cgst || 0), 0);
        const totalSGST = gstRows.reduce((sum, g) => sum + Number(g.sgst || 0), 0);
        const totalIGST = gstRows.reduce((sum, g) => sum + Number(g.igst || 0), 0);
        // Inter-state only if EVERY slab is inter-state (igst > 0). If your
        // business only ever does one or the other per invoice this is moot,
        // but it's correct either way instead of guessing from slab #1 alone.
        const isIntraState = gstRows.length
          ? gstRows.every((g) => Number(g.igst || 0) === 0)
          : getStateCode(customers?.state || "") ===
            getStateCode(orgDetails?.address?.[0]?.state || "");

        setFormData((prev) => ({
          ...prev,
          ...invoiceData,
          invoiceDate: invoiceData.invoiceDate?.split("T")[0] || "",
          dueDate: invoiceData.dueDate?.split("T")[0] || "",
          itemDetails: invoiceData.items || [],
          buyerStateCode: gstRows[0]?.buyerStateCode ?? getStateCode(customers?.state || ""),
          sellerStateCode: gstRows[0]?.sellerStateCode ?? getStateCode(orgDetails?.address?.[0]?.state || ""),
          isIntraState,
          totalCGST,
          totalSGST,
          // NOTE: previously used formData.totalTax directly for the IGST line
          // (invoice-level totalTax happened to be correct since your backend
          // sums it server-side) — totalIGST below is the same idea but computed
          // client-side from gstDetails so it stays correct even if totalTax
          // ever includes something other than pure GST (shipping tax, etc.)
          totalTax: invoiceData?.totalTax ?? totalCGST + totalSGST + totalIGST,
          buyerGST: gstRows[0]?.buyerGST ?? "",
          sellerGST: gstRows[0]?.sellerGST ?? orgDetails?.GST ?? "",
          paymentMode: invoiceData?.paymentMode || "",
        }));
      } catch (err) {
        console.error("Failed to fetch invoice:", err);
      }
    };

    fetchInvoice();
  }, [invoiceId]);

  // Derived IGST total for display (kept separate from formData so we don't
  // need to touch the IInvoiceData interface).
  const totalIGST = gstDetailRows.reduce((sum, g) => sum + Number(g.igst || 0), 0);

  // ── Preview / Print / Download / WhatsApp dialog ─────────────────────────
  const [previewOpen, setPreviewOpen] = useState(false);
  const [waPhone, setWaPhone] = useState(customers?.phone ?? "");
  const [waStatus, setWaStatus] = useState<string | null>(null);
  const [busy, setBusy] = useState<"" | "print" | "download" | "whatsapp">("");
  const previewRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (customers?.phone) setWaPhone(customers.phone);
  }, [customers?.phone]);

  const handlePrint = () => {
    setPreviewOpen(true);
  };

  // ─────────────────────────────────────────────────────────────────────────
  // IMPORTANT: the three actions below assume `printViewInvoicePDF` can be
  // called in a way that returns the jsPDF `doc` (or a Blob) instead of
  // immediately triggering window.print()/doc.save(). I don't have
  // CommonService.ts, so these are wired to the ORIGINAL behavior (direct
  // print) for now, plus TODOs showing exactly what to change once you share
  // that file — it's a small refactor (return `doc` instead of calling
  // `doc.autoPrint()` / `doc.save()` inside printViewInvoicePDF itself).
  // ─────────────────────────────────────────────────────────────────────────

  const confirmPrint = async () => {
    setBusy("print");
    try {
      // "print" mode: opens the PDF in a new tab with auto-print triggered,
      // instead of downloading a file.
      printViewInvoicePDF(orgDetails, formData, customers, taxSummary, "print");
    } catch (error: any) {
      alert(`Failed to print invoice: ${error.message}`);
    } finally {
      setBusy("");
    }
  };

  const confirmDownload = async () => {
    setBusy("download");
    try {
      printViewInvoicePDF(orgDetails, formData, customers, taxSummary, "download");
    } catch (error: any) {
      alert(`Failed to generate PDF: ${error.message}`);
    } finally {
      setBusy("");
    }
  };

  const confirmWhatsAppShare = async () => {
    if (!waPhone.trim()) {
      setWaStatus("Enter the customer's WhatsApp number first.");
      return;
    }
    setBusy("whatsapp");
    setWaStatus(null);
    try {
      const blob = printViewInvoicePDF(orgDetails, formData, customers, taxSummary, "blob") as Blob;
      const message = buildInvoiceWhatsAppMessage(formData.invoiceId, formData.customerName, formData.grandTotal);
      const result = await shareInvoicePdf(blob, `${formData.invoiceId.replace(/\//g, "_")}.pdf`, waPhone, message);
      if (result.method === "web-share") {
        setWaStatus("Shared via WhatsApp ✅");
      } else if (result.method === "manual-attach") {
        setWaStatus("PDF downloaded and WhatsApp chat opened — drag the PDF into the chat to send it.");
      }
    } catch (error: any) {
      setWaStatus("Could not prepare the PDF for sharing.");
    } finally {
      setBusy("");
    }
  };

  return (
    <>
      <div className="page-location">
        <span>Sales &gt; View Invoice &gt; Invoice Details</span>
      </div>
      <button onClick={handleBackClick} className="back-button">
        <i className="fas fa-arrow-left back-icon"></i>
        Back
      </button>
      <Container maxWidth="lg" sx={{ padding: 1 }}>
        <form>
          <form className="invoice-form">
            <div className="view-form-group">
              <label>Invoice ID: </label>
              {formData?.invoiceId}
            </div>

            <div className="view-form-group">
              <label>Customer Name: </label>
              {formData?.customerName}
            </div>
            <div className="view-form-group">
              <label>Invoice Date: </label>
              {formData?.invoiceDate
                ? new Date(formData.invoiceDate).toLocaleDateString("en-GB")
                : "N/A"}
            </div>

            <div className="view-form-group">
              <label>Buyer's Order No</label>
              {formData?.orderId}
            </div>

            <div className="view-form-group">
              <label>Buyer's Order Date</label>
              {formData?.orderDate
                ? new Date(formData.orderDate).toLocaleDateString("en-GB")
                : "N/A"}
            </div>

            <div className="view-form-group">
              <label>Sales Person: </label>
              {formData?.salesPersonName}
            </div>
            <div className="view-form-group">
              <label>Mode/Terms Payment: </label>
              {formData?.paymentMode}
            </div>
          </form>

          <div className="invoice-items-container">
            <h2>Item Details</h2>
            {formData?.itemDetails?.map((item: IInvoiceItem, index: number) => (
              <>
                <label
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    color: "#333",
                    marginBottom: "5px",
                    display: "block",
                  }}
                >
                  Sno: {index + 1}
                </label>
                <div key={index} className="item-row">
                  <label>Item Name:</label>
                  <input
                    type="text"
                    placeholder="Item Description"
                    className="item-input"
                    value={item?.itemDesc}
                    disabled
                  />
                  <label>Quantity:</label>
                  <input
                    type="number"
                    placeholder="Quantity"
                    className="item-input"
                    value={item?.qty}
                    disabled
                  />
                  <label>Rate:</label>
                  <input
                    type="number"
                    placeholder="Rate"
                    className="item-input"
                    value={item?.price}
                    disabled
                  />
                </div>
                <div key={index} className="item-row">
                  <label>Discount:</label>
                  <select className="item-input" value={item?.discount} disabled>
                    <option value="0">No Discount</option>
                    <option value="5">5%</option>
                    <option value="10">10%</option>
                    <option value="15">15%</option>
                    <option value="20">20%</option>
                  </select>
                  <label>Tax:</label>
                  <select className="item-input" value={item?.Tax} disabled>
                    <option value="0">Tax Not Applicable</option>
                    <option value="3">3%</option>
                    <option value="5">5%</option>
                    <option value="12">12%</option>
                    <option value="18">18%</option>
                    <option value="28">28%</option>
                  </select>
                  <label>Total:</label>
                  <input
                    type="text"
                    className="item-input"
                    value={(
                      Number(item?.qty) *
                      Number(item?.price) *
                      (1 - Number(item?.discount) / 100) *
                      (1 + Number(item?.Tax) / 100)
                    ).toFixed(2)}
                    disabled
                  />
                </div>
              </>
            ))}
          </div>

          {/* ── GST breakdown by slab — this is what was missing before ── */}
          {gstDetailRows.length > 0 && (
            <div className="invoice-items-container" style={{ marginTop: 16 }}>
              <h2>GST Breakdown</h2>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Rate</TableCell>
                    <TableCell align="right">Taxable Value</TableCell>
                    {formData.isIntraState ? (
                      <>
                        <TableCell align="right">CGST</TableCell>
                        <TableCell align="right">SGST</TableCell>
                      </>
                    ) : (
                      <TableCell align="right">IGST</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {gstDetailRows.map((g, i) => (
                    <TableRow key={i}>
                      <TableCell>{g.gstRate}%</TableCell>
                      <TableCell align="right">{Number(g.taxableValue).toFixed(2)}</TableCell>
                      {formData.isIntraState ? (
                        <>
                          <TableCell align="right">{Number(g.cgst).toFixed(2)}</TableCell>
                          <TableCell align="right">{Number(g.sgst).toFixed(2)}</TableCell>
                        </>
                      ) : (
                        <TableCell align="right">{Number(g.igst).toFixed(2)}</TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}

          <div className="calculation-container">
            <div className="form-group">
              <label>Sub Total: {formData?.subTotalAmount.toFixed(2)}</label>
            </div>
            {formData.isIntraState ? (
              <>
                <div className="form-group">
                  <label>CGST: {formData?.totalCGST?.toFixed(2)}</label>
                </div>
                <div className="form-group">
                  <label>SGST: {formData?.totalSGST.toFixed(2)}</label>
                </div>
              </>
            ) : (
              <div className="form-group">
                <label>IGST: {totalIGST.toFixed(2)}</label>
              </div>
            )}
            <div className="form-group">
              <label>
                Shipping Charge:
                {formData?.shippingCharge > 0
                  ? `${formData?.shippingCharge.toFixed(2)}`
                  : ""}
              </label>
            </div>
              <div className="form-group">
              <label>Round Off: {formData?.roundOff?.toFixed(2)} </label>
            </div>
            <div className="form-group">
              <label>Total: {formData?.grandTotal.toFixed(2)} </label>
            </div>
            <div className="form-group">
              <label>Paid Amount: {formData?.totalPaidAmount.toFixed(2)} </label>
            </div>
          </div>
          <button type="button" onClick={handlePrint} className="print-button">
            Print
          </button>
        </form>
      </Container>

      {/* ── Preview → Print / Download / WhatsApp ────────────────────────── */}
      <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Invoice Preview
          <IconButton size="small" onClick={() => setPreviewOpen(false)}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box ref={previewRef}>
            <Typography variant="subtitle1" fontWeight={700}>{formData.invoiceId}</Typography>
            <Typography variant="body2">{formData.customerName}</Typography>
            <Typography variant="body2" color="text.secondary">
              {formData.invoiceDate ? new Date(formData.invoiceDate).toLocaleDateString("en-GB") : "N/A"}
            </Typography>
            <Box mt={1}>
              <Typography variant="body2">Subtotal: {formData.subTotalAmount.toFixed(2)}</Typography>
              {formData.isIntraState ? (
                <>
                  <Typography variant="body2">CGST: {formData.totalCGST.toFixed(2)}</Typography>
                  <Typography variant="body2">SGST: {formData.totalSGST.toFixed(2)}</Typography>
                </>
              ) : (
                <Typography variant="body2">IGST: {totalIGST.toFixed(2)}</Typography>
              )}
              <Typography variant="subtitle2" fontWeight={700}>Grand Total: {formData.grandTotal.toFixed(2)}</Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ flexDirection: "column", alignItems: "stretch", gap: 1, p: 2 }}>
          <Stack direction="row" spacing={1}>
            <TextField
              size="small"
              fullWidth
              label="Customer WhatsApp number"
              value={waPhone}
              onChange={(e) => setWaPhone(e.target.value)}
            />
            <Button variant="outlined" color="success" startIcon={<WhatsAppIcon />} disabled={busy !== ""} onClick={confirmWhatsAppShare}>
              {busy === "whatsapp" ? "Preparing…" : "Share"}
            </Button>
          </Stack>
          {waStatus && <Typography variant="caption" color="text.secondary">{waStatus}</Typography>}
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button onClick={() => setPreviewOpen(false)}>Close</Button>
            <Button variant="outlined" startIcon={<DownloadIcon />} disabled={busy !== ""} onClick={confirmDownload}>
              {busy === "download" ? "Generating…" : "Download PDF"}
            </Button>
            <Button variant="contained" startIcon={<PrintIcon />} disabled={busy !== ""} onClick={confirmPrint}>
              Print
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          position: "relative",
          left: 0,
          bottom: 0,
          width: "100%",
          mt: 10,
        }}
      >
        <Footer />
      </Box>
    </>
  );
};
export default ViewInvoiceDetails;